import { useContext } from 'react';

import { LayerContext } from 'state/LayerContext';
import { useGetSegmentInfoQuery } from 'state/apiSlice';
import { useAppSelector } from 'state/hooks';
import { selectProject, selectSegmentId } from 'state/workflowSlice';

import { capitalizeFirstLetter, formatSpeed } from '../utils';

export const useSegmentProperties = () => {
  const segmentId = useAppSelector(selectSegmentId);
  const userProject = useAppSelector(selectProject);

  const { layer } = useContext(LayerContext);
  const { currentData: segmentData } = useGetSegmentInfoQuery(
    { layerId: layer, routeIds: [segmentId] },
    { skip: !layer || !segmentId },
  );
  const segment = segmentData?.segments?.[segmentId];
  const segmentProperties = segment?.properties;

  if (!segmentProperties) return null;

  const { name, freeflow_speed_mph, cardinal_dir } = segmentProperties;
  return {
    segment,
    freeflowSpeed: formatSpeed(freeflow_speed_mph, userProject.uses_metric),
    name,
    cardinalDirection: cardinal_dir
      ? capitalizeFirstLetter(cardinal_dir)
      : 'Unknown',
  };
};
